import { render, staticRenderFns } from "./BlogLayouts.vue?vue&type=template&id=55cf02de&scoped=true"
import script from "./BlogLayouts.vue?vue&type=script&lang=js"
export * from "./BlogLayouts.vue?vue&type=script&lang=js"
import style0 from "./BlogLayouts.vue?vue&type=style&index=0&id=55cf02de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cf02de",
  null
  
)

export default component.exports